module.exports = __webpack_public_path__ + "static/img/40010 (3).d6729eb.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/40000/40010 (3).webp
// module id = hI14
// module chunks = 14